import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs";
import { quickCommerceApiColletions } from "src/app/core/constants/api_collection";

@Injectable({
  providedIn: "root"
})
export class QuickCommerseService {
  constructor(private apiService: ApiService) {}
  acceptBooking(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const url = `${quickCommerceApiColletions.acceptBooking}/${parameters._id}`;
      this.apiService.put({ url: url, parameters: {} }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  changeBookingStatus(bookingId: string, parameters: any): Observable<boolean> {
    return new Observable<any>((observer) => {
      const changeBookingStatusUrl = `${quickCommerceApiColletions.changeBookingStatus}/${bookingId}`;
      this.apiService.put({ url: changeBookingStatusUrl, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  acceptMerchantBooking(bookingId: string, parameters: any): Observable<boolean> {
    return new Observable<any>((observer) => {
      const acceptBookingUrl = `${quickCommerceApiColletions.acceptMerchantBooking}/${bookingId}`;
      this.apiService.put({ url: acceptBookingUrl, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  reAssingPicker(bookingId: string, parameters: any): Observable<boolean> {
    return new Observable<any>((observer) => {
      const reAssingPickerUrl = `${quickCommerceApiColletions.reAssignPicker}/${bookingId}`;
      this.apiService.post({ url: reAssingPickerUrl, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
}
